import { get, post } from "./Service";

export const getAnonymousUser = (userName, onDone) => {
    get(`/api/security/anonymous/${userName}`, user => {
        onDone(user);
    });
};

export const validatePreviouslyUsed = (payload, onDone) => {
    post("/api/security/check-repeat-password", payload, (res) => {
        onDone(res.data);
    });
};

export const logout = (onDone) => {
    get("/api/security/logout", res => {
        onDone(res);
    });
};

export const sessionTimeOut = (onDone) => {
    get("/api/security/session-time-out", res => {
        onDone(res);
    });
};

export const getProduct = (onDone) => {
    get("/api/security/get-product", res => {
        onDone(res && res.data ? res.data : 'LIMS-ELN');
    });
};

export const getAuthorizationUrl = (authConfig, onDone) => {
    const { clientId, redirectUri, scope, responseType, state } = authConfig;
    const url = new URL('https://authorization-server.com/oauth/authorize');
    url.searchParams.set('client_id', clientId);
    url.searchParams.set('redirect_uri', redirectUri);
    url.searchParams.set('scope', scope);
    url.searchParams.set('response_type', responseType);
    url.searchParams.set('state', state);
    onDone(url.toString());
};

const getId = () => JSON.parse(localStorage.getItem("id")) || "anonymous";
export const getToken = (authId, onDone) => {
    const id = getId();
    get(`/api/security/token/${authId}/${id}`, token_response => {
        let token = token_response && token_response.data;
        onDone(token);
    });
};

export const getInstrospect = onDone => {
    get("/api/security/introspect", res => {
        let me = res && res.data;
        onDone(me);
    });
};

export const getOAuthConfig = async () => {
    return new Promise((resolve, reject) => {
        console.log("Fetching OAuth config...");

        get("/api/security/auth/oauth2/config", (response) => {
            if (!response || typeof response !== "object") {
                console.error("Invalid OAuth config response:", response);
                return reject(new Error("Invalid OAuth config response"));
            }

            console.log("OAuth Config Response:", response);
            resolve(response); // Return response properly
        });
    });
};

export async function exchangeCodeForToken(code) {
    const oauthConfig = await getOAuthConfig();

    const codeVerifier = sessionStorage.getItem('code_verifier');
    if (!codeVerifier) {
        throw new Error("Missing code_verifier from localStorage.");
    }

    if (!oauthConfig.client_id || !oauthConfig.redirect_uri || !code) {
        throw new Error("Missing required OAuth parameters!");
    }

    const tokenEndpoint = `https://login.microsoftonline.com/${oauthConfig.tenant_id}/oauth2/v2.0/token`;

    const params = new URLSearchParams();
    params.append("client_id", oauthConfig.client_id);
    params.append("redirect_uri", oauthConfig.redirect_uri);
    params.append("code", code);
    params.append("grant_type", "authorization_code");
    params.append("scope", oauthConfig.scope);
    params.append("code_verifier", codeVerifier); // 👈 VERY IMPORTANT

    try {
        const response = await fetch(tokenEndpoint, {
            method: "POST",
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
            },
            body: params,
        });

        const data = await response.json();
        if (!response.ok) {
            throw new Error(`OAuth Token Error: ${data.error_description || data.error}`);
        }

        return data;
    } catch (error) {
        console.error("OAuth Exchange Error:", error);
        throw error;
    }
}


// export const getOAuthConfig = async () => {
//     try {
//         console.log("Fetching OAuth config...");
//         const response = await get("/api/security/auth/oauth2/config"); // Ensure correct API call
//         console.log("OAuth Config Response:", response);
//         if (response && response.data) {
//             return response.data; // Ensure it returns the data property
//         } else if (response) {
//             return response; // Handle cases where data is directly in the response
//         } else {
//             throw new Error("Invalid response from server");
//         }
//     } catch (err) {
//         console.error("Error fetching OAuth config:", err);
//         throw err; // Ensure error is properly handled
//     }
// };

